import { render, staticRenderFns } from "./AdvancedMessageEditor.vue?vue&type=template&id=89eb6c60&scoped=true"
import script from "./AdvancedMessageEditor.vue?vue&type=script&lang=ts"
export * from "./AdvancedMessageEditor.vue?vue&type=script&lang=ts"
import style0 from "./AdvancedMessageEditor.vue?vue&type=style&index=0&id=89eb6c60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eb6c60",
  null
  
)

export default component.exports